










































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  Table as DataTable,
  Pill,
  Dropdown,
  SvgIcon,
  LottieAnimation,
  Button,
  Message,
} from "@brankas/web-ui";
import { namespace } from "vuex-class";
import { TableColumn, ClientInfo, UserListItem } from "@/types";
import { ClientState } from "@/stores/modules";

import DeactivateUserDialog from "./dialogs/DeactivateUserDialog.vue";

// TODO: Support pagination later

const clientModule = namespace("client");

@Component({
  components: {
    DataTable,
    Pill,
    Dropdown,
    SvgIcon,
    LottieAnimation,
    Button,
    Message,
    DeactivateUserDialog,
  },
})
export default class UserList extends Vue {
  @Prop({ type: String, default: null }) clientId!: string | null;

  @clientModule.Action("getListUsers") getListUsers!: (payload: {
    clientId: string;
  }) => UserListItem[];
  @clientModule.Action("deactivateUser") deactivateUser!: (payload: {
    userId: string;
  }) => void;

  @clientModule.State("userList") userList!: ClientState["userList"];
  @clientModule.State("currentClient") clientInfo!: ClientInfo;

  successMsg = "";
  errorMsg = "";
  loading = false;
  tableColumns: TableColumn[] = [
    {
      label: "NAME",
      field: "name",
      width: "20%",
      sortable: false,
      tdClass: "font-sans font-medium",
    },
    {
      label: "CREATED",
      field: "created",
      width: "13%",
      sortable: true,
      tdClass: "font-sans font-medium text-sm",
    },
    {
      label: "ROLE",
      field: "role",
      width: "10%",
      sortable: false,
      tdClass: "font-sans font-medium text-sm",
    },
    {
      label: "EMAIL",
      field: "email",
      width: "23%",
      sortable: false,
      tdClass: "font-sans font-medium text-sm",
    },
    {
      label: "LAST LOGIN",
      field: "lastlogin",
      width: "15%",
      sortable: true,
      tdClass: "font-sans font-medium",
    },
    {
      label: "STATUS",
      field: "isactive",
      width: "14%",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
      with: "5%",
    },
  ];
  isShowingDeactivatePrompt = false;
  selectedUser = null;
  moreOptions(data) {
    return [
      {
        label: "Deactivate",
        action: () => {
          this.isShowingDeactivatePrompt = true;
          this.selectedUser = data;
        },
      },
    ];
  }

  get rows() {
    return this.userList.map((data) => ({
      name: data.name || "",
      created: data.created || "",
      role: data?.role?.name || "",
      email: data.email || "",
      lastlogin: data.lastlogin || "",
      isactive: data.isactive || "",
      action: data || "",
    }));
  }

  get isLastActiveUser() {
    let activeCount = 0;

    this.userList.forEach((data) => {
      if (data.isactive) {
        activeCount++;
      }
    });

    return activeCount === 1;
  }

  @Watch("clientId", { immediate: true })
  watchClientId() {
    this._fetchUsersList();
  }

  async _fetchUsersList() {
    if (!this.clientId) return;

    this.loading = true;
    try {
      await this.getListUsers({
        clientId: this.clientId,
      });
    } catch (err) {
      console.error(err);
      this.errorMsg = err.message;
    } finally {
      this.loading = false;
    }
  }

  async _deactivateUser() {
    if (!this.clientId) return;

    this.loading = true;
    this.successMsg = "";
    this.errorMsg = "";

    try {
      await this.deactivateUser({
        userId: this.selectedUser.id,
      });
      this.successMsg = "User deactivated";
      this._fetchUsersList();
    } catch (err) {
      console.error(err);
      this.errorMsg = err.message;
    } finally {
      this.loading = false;
      this.isShowingDeactivatePrompt = false;
      this.selectedUser = null;
    }
  }
}
